// eslint-disable-next-line import/prefer-default-export
export function initTagManager(id = 'GTM-KD2RSKVH') {
  // Évite d'injecter deux fois le même script
  if (document.getElementById('gtm-script')) return;

  // ----- Script principal (head) -----
  const gtmScript = document.createElement('script');
  gtmScript.id = 'gtm-script';
  gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${id}');`;
  document.head.appendChild(gtmScript);

  // ----- Noscript (body) -----
  const noScript = document.createElement('noscript');
  noScript.id = 'gtm-noscript';
  noScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.prepend(noScript);
}
